import { Injectable } from '@angular/core';
import { AlloxApiService } from './allox-api.service';
import { map } from 'rxjs/operators';
import { User } from '../models/user.model';
import { UserListSearchParam } from '../models/user-list-search-param.model';

/**
 * ユーザーリストのサービスクラス
 * @@Injectable デコレーターでルートプロバイダーとして登録
 */
@Injectable({ providedIn: 'root' })
export class UserListService {

  /**
   * APIのエンドポイントパス
   * @type {string}
   */
  private path = '/users';

  /**
   * コンストラクタ
   * @param {AlloxApiService} http - AlloxApiServiceのインスタンス
   */
  constructor(private http: AlloxApiService) { }

  /**
   * ユーザーリストを検索する
   * @param {UserListSearchParam} param - 検索パラメータ
   * @returns {Observable<User[]>} ユーザーリストのObservable
   */
  public search(param: UserListSearchParam) {
    let url = this.path;
    if (param) {
      url += param.toURLQuery();
    }
    return this.http.get<[]>(url).pipe(
      map(objs => objs.map(obj => new User(obj))),
    );
  }

  /**
   * ユーザーリストの削除
   * @param {User[]} items - 削除対象のユーザーリスト
   * @returns {Observable<any>} 削除結果のObservable
   */
  public deletes(items: User[]) {
    const dItems = items.map(item => item.toDeleteItemJSON());
    return this.http.post(this.path + '/delete', { delete_items: dItems });
  }
}
